module.exports = __webpack_public_path__ + "img/excellent.4b80c6ce.png";